import * as React from 'react';
import { Modal } from '@mantine/core';
import { styled, useTheme } from '../theme/theme';
import { LottieClose } from './Lottie';

type TModalContent = {
  trigger: React.ReactNode;
  content: React.ReactNode;
  className?: string;
};

export const ModalContent = ({
  className,
  content,
  trigger,
}: TModalContent) => {
  const [open, setOpen] = React.useState(false);
  const onOpen = React.useCallback(() => setOpen(true), [setOpen]);
  const onClose = React.useCallback(() => setOpen(false), [setOpen]);
  return (
    <Root className={className}>
      <Trigger onClick={onOpen}>
        {trigger}
      </Trigger>
      <ModalContentView
        open={open}
        onClose={onClose}
        content={content}
      />
    </Root>
  );
};

type TModalContentViewProps = {
  open: boolean;
  onClose: () => void;
  content: React.ReactNode;
};

export const ModalContentView = ({
  open,
  onClose,
  content,
}: TModalContentViewProps) => {
  const theme = useTheme();
  return (
    <StyledModal
      opened={open}
      onClose={onClose}
      fullScreen
      withCloseButton={false}
      styles={{
        body: { backgroundColor: 'transparent' },
        content: { backgroundColor: 'transparent' },
      }}
    >
      <StyledModalContent>
        <ContentWrapper>
          {content}
        </ContentWrapper>
        <StyledClose onClick={onClose}>
          <LottieClose color={[theme.legacy.colors.accent1]} />
        </StyledClose>
      </StyledModalContent>
    </StyledModal>
  );
};

const Root = styled.div`
`;

const Trigger = styled.div`
  cursor: pointer;
`;

const StyledModal = styled(Modal)`
`;

const StyledModalContent = styled.div`
  align-items: center;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8vw;
  min-height: 100%;
`;

const ContentWrapper = styled.div`
  margin-top: 30px;
  max-height: 90vh;
  max-width: min(90vw, 90vh);
  overflow-y: scroll;
`;

const StyledClose = styled.div`
  cursor: pointer;
  margin-top: -30px;
  width: 128px;
`;
